import { render, staticRenderFns } from "./MedicalPageForm.vue?vue&type=template&id=101f4e8f&"
import script from "./MedicalPageForm.vue?vue&type=script&lang=js&"
export * from "./MedicalPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpinnerPuff,QBtn,QItem,QSelect,QIcon,QItemSection,QImg,QList,QSeparator,QCheckbox,QAvatar,QSpinnerGears,QCardActions,QBtnDropdown,QOptionGroup,ClosePopup} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QSpinnerPuff,QBtn,QItem,QSelect,QIcon,QItemSection,QImg,QList,QSeparator,QCheckbox,QAvatar,QSpinnerGears,QCardActions,QBtnDropdown,QOptionGroup}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
